import styled from 'styled-components';

export const ProductsListContainer = styled.div`
    max-height: ${(props) => props.theme.blockWidth.sm};
    background-color: ${(props) => props.theme.wab.white20};
    overflow-y: auto;
    padding: ${(props) => props.theme.space.sm};
`;
